"use client";

import Image from "next/image";
import Link from "next/link";

import { DateUtils } from "@/utils/date";
import { WHATSAPP_LINK } from "@/constants/links";
import { logEvent } from "@/services/firebase";

interface IInformation {
  key: string;
  title: string;
  content: React.ReactNode;
}

const informations: IInformation[] = [
  {
    key: "address",
    title: "Endereço",
    content: (
      <Link
        href="https://www.google.com/maps/place/Domynique+Mota+%7C+Nutrição+e+Saúde/@-23.6179464,-46.6428652,17z/data=!3m1!4b1!4m6!3m5!1s0x4e77f74df345ca1d:0xbaf5817774422c3a!8m2!3d-23.6179514!4d-46.6379889!16s%2Fg%2F11y7h0p_qk?entry=ttu&g_ep=EgoyMDI1MDQwMi4xIKXMDSoJLDEwMjExNjM5SAFQAw%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => logEvent("endereco_click", { section: "footer" })}
      >
        <address className="not-italic">
          <p>R. Pereira Estéfano, 114, Sala 408</p>
          <p>Vila da Saúde, São Paulo - SP</p>
          <p>CEP: 04144-070</p>
        </address>
      </Link>
    ),
  },
  {
    key: "contacts",
    title: "Contatos",
    content: (
      <>
        <p>
          <Link
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ligar para (11) 96064-0542"
            onClick={() =>
              logEvent("agendar_consulta_click", { section: "footer" })
            }
          >
            Telefone: (11) 96064-0542
          </Link>
        </p>
        <p>CNPJ: 59.511.870/0001-78</p>
        <p>Domynique Mota Nutricao e Saude</p>
      </>
    ),
  },
];

export const Footer = () => {
  const currentYear = DateUtils.getCurrentYear();

  return (
    <footer className="bg-secondary text-white py-8 md:py-12 lg:pt-16">
      <div className="max-w-7xl mx-auto flex px-4 sm:px-6 lg:px-8 flex-col sm:flex-row gap-12 md:gap-16 items-start">
        <Link
          className="filter brightness-200"
          href="/"
          aria-label="Ir para página inicial"
        >
          <Image
            src="/images/logo-full.png"
            alt="Logotipo da empresa"
            width={260}
            height={68}
            className="block sm:hidden cursor-pointer w-52 h-14"
            priority
          />
          <Image
            src="/images/logo-mini.png"
            alt="Logotipo da empresa"
            width={40}
            height={40}
            className="hidden sm:block w-16 h-16"
            loading="lazy"
          />
        </Link>

        {informations.map(({ key, title, content }) => (
          <div key={key} className="text-base">
            <h3 className="font-semibold mb-2">{title}</h3>
            <div>{content}</div>
          </div>
        ))}
      </div>

      <hr className="border-white/20 my-8" />

      <div className="text-center mx-auto px-4 sm:px-6 lg:px-8">
        <small className="text-base">
          &copy; {currentYear} Domynique Mota | Todos os direitos reservados.
        </small>
      </div>
    </footer>
  );
};
